'use client'

import { useEffect, type RefObject } from 'react'

type Args = {
  targetRef: RefObject<HTMLElement | null>
  onLoadMore: () => void
  enabled?: boolean
  threshold?: number
  rootMargin?: string
}

// rootMargin: fetch the next page ~1.5 screens early so fast scrolling never hits
// an empty wall and then jumps when the batch lands.
export function useInfiniteScroll({ targetRef, onLoadMore, enabled = true, threshold = 0, rootMargin = '1200px' }: Args) {
  useEffect(() => {
    if (!enabled || !targetRef.current) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) onLoadMore()
      },
      { threshold, rootMargin }
    )
    observer.observe(targetRef.current)
    return () => observer.disconnect()
  }, [targetRef, onLoadMore, enabled, threshold, rootMargin])
}
